module.exports = __webpack_public_path__ + "themes/fq/font/SignPainter-HouseScript.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/SignPainter-HouseScript.woff
// module id = 89
// module chunks = d-game